<script setup>
import { ref, onMounted } from 'vue';
import { $api } from '@/services';
import { useRoute } from 'vue-router';
import Loading from '@/components/common/Loading.vue';
import ListQuestion from './ListQuestion.vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const route = useRoute();
const id = route.params.id;
const template = ref(null);
const router = useRouter();
const isLoading = ref(true);
const store = useStore();

onMounted(() => {
	fetchSurveyTemplateDetail();
});

const fetchSurveyTemplateDetail = async () => {
	const res = await $api.survey.getTemplateDetail(id);
	template.value = res.data.data;
	isLoading.value = false;
};

const useTemplate = async () => {
	try {
		router.push('/survey/create?templateId=' + template.value.id);
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message:
				err?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
};
</script>
<template>
	<div class="px-12 md-down:px-4 p-10">
		<div v-if="isLoading">
			<Loading />
		</div>
		<div v-else>
			<div
				class="flex items-center gap-2 text-sm text-neutral-500 font-semibold mb-4"
			>
				<div
					class="cursor-pointer"
					@click="$router.push('/survey?tab=template')"
				>
					Biểu mẫu của trung tâm
				</div>
				<img alt="" src="@/assets/images/icons/arrow-right.png" />
				<div>{{ template?.name }}</div>
			</div>

			<div class="flex items-center justify-between mb-2">
				<div class="flex flex-nowrap justify-between items-center">
					<div
						class="text-neutral-700 font-bold whitespace-pre-wrap flex flex-nowrap items-center text-4xl gap-3"
					>
						<img
							src="@/assets/images/icons/arrow-right.png"
							alt=""
							class="w-5 h-5 cursor-pointer"
							style="transform: rotate(180deg)"
							@click="$router.push('/survey')"
						/>
						<img
							src="@/assets/images/icons/form-evaluation.png"
							class="w-7 h-7"
						/>
						<div>{{ template?.name }}</div>
					</div>
				</div>
				<button
					class="button-p text-center whitespace-nowrap w-max"
					type="button"
					@click="useTemplate"
				>
					Dùng biểu mẫu
				</button>
			</div>
			<ListQuestion :survey="template" />
		</div>
	</div>
</template>